import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingPlaceholder from './LoadingPlaceholder';
import AppModal from './AppModal'; // Import the AppModal component

const Appwalls = () => {
    const [appDetails, setAppDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedApp, setSelectedApp] = useState(null);
    const [showModal, setShowModal] = useState(false); // State to manage modal visibility

    useEffect(() => {
        const fetchData = async () => {
            const url = `${site['site_url']}/ajax/tp.core.php?action=get.Offerwall`;
            try {
                const response = await axios.post(url, {}, { withCredentials: true });
                if (response.data.status === 'success') {
                    const appDetailsArray = Object.values(response.data.data);
                    setAppDetails(appDetailsArray);
                } else {
                    setError('No data available.');
                }
            } catch (error) {
                setError('Failed to load data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleItemClick = (app) => {
        if(data['id']){
            setSelectedApp(app);
            setShowModal(true); // Show the modal
        } else {
            const signInModal = new bootstrap.Modal(document.getElementById('SigninForm'));
            signInModal.show();
        }
    };

    const closeModal = () => {
        setShowModal(false); // Close modal by updating state
        setSelectedApp(null); // Clear selected app
    };

    const generateListItem = (val) => {
        return (
            <li className="nav-item flex-shrink-0 me-2" key={val.id} onClick={() => handleItemClick(val)}>
                <div className="card" style={{ width: "100px" }}>
                    <img src={val.app_icon} className="card-img-top" alt={val.app_name} />
                    <div className="card-body p-2">
                        <strong className="text-muted fs-6 d-block text-truncate mt-2">{val.app_name}</strong>
                        <small className="text-muted fs-6">{val.platform === 'android' ? (<i className="fab fa-android"></i>) : val.platform === 'ios' ? (<i className="fab fa-apple"></i>) : (<i class="fas fa-globe"></i>)}</small>
                        <div className="row justify-content-between align-items-center mt-2">
                            <div className="col-auto">
                                <strong className="fs-7">{`$ ${Number(val.payout_usd).toFixed(2)}`}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        );
    };

    if (loading) {
        return <LoadingPlaceholder />;
    }
    if (error) {
        return <div>{error}</div>;
    }
    return (
        <>
            <ul id="appDetails" className="nav overflow-auto p-0 offer-list">
                {appDetails.length > 0 ? appDetails.map(generateListItem) : ''}
            </ul>
            {showModal && <AppModal selectedApp={selectedApp} closeModal={closeModal} />}
        </>
    );
};

export default Appwalls;
